export default {
    AMEX: 'amex',
    AURA: 'aura',
    DINERS: 'diners',
    DISCOVER: 'discover',
    ELO: 'elo',
    HIPERCARD: 'hipercard',
    JCB: 'jcb',
    MASTERCARD: 'master',
    VISA: 'visa',
    ALELO: 'Alelo',
};